import {RotationOrigin} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/rotation/RotationOrigin';
import {Property} from '@mintdata/mint-kit/api/decorators/Property';
import {BindingConfig, BindingIconPlace, BindingTooltipPlace} from '@mintdata/mint-kit/api/properties/BindingConfig';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {ANumber} from '@mintdata/mint-kit/api/values/ANumber';
import {ABooleanConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ABooleanConfig';
import {AStringEnumConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/AEnumConfig';
import {ANumberConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ANumberConfig';
import * as React from 'react';
import {CSSProperties} from 'react';

export class RotationModel
{
    @Property<ABoolean>({
        title: 'Rotation enabled',
        tip: 'Rotation enabled',
        isRequired: true,
        typeConfig: ABooleanConfig,
        typeCtor: ABoolean,
        binding: BindingConfig.with(null, BindingIconPlace.RightMiddle, BindingTooltipPlace.Right)
    })
    isEnabled:ABoolean;

    @Property<ANumber>({
        title: 'Rotation X angle',
        tip: `Rotation X angle`,
        isRequired: true,
        typeConfig: ANumberConfig,
        typeCtor: ANumber
    })
    angleX:ANumber;

    @Property<ANumber>({
        title: 'Rotation Y angle',
        tip: `Rotation Y angle`,
        isRequired: true,
        typeConfig: ANumberConfig,
        typeCtor: ANumber
    })
    angleY:ANumber;

    @Property<ANumber>({
        title: 'Rotation Z angle',
        tip: `Rotation Z angle`,
        isRequired: true,
        typeConfig: ANumberConfig,
        typeCtor: ANumber
    })
    angle:ANumber;

    @Property<RotationOrigin>({
        title: 'Rotation origin',
        tip: `Rotation origin`,
        isRequired: true,
        typeConfig: AStringEnumConfig,
        typeCtor: RotationOrigin
    })
    origin:RotationOrigin;

    public constructor(isEnabled:ABoolean,
                       angleX:ANumber,
                       angleY:ANumber,
                       angleZ:ANumber,
                       origin:RotationOrigin)
    {
        this.isEnabled = isEnabled;
        this.angleX = angleX;
        this.angleY = angleY;
        this.angle = angleZ;
        this.origin = origin;
    }

    public static default():RotationModel
    {
        return new RotationModel(
            ABoolean.false(),
            ANumber.fromNumber(0),
            ANumber.fromNumber(0),
            ANumber.fromNumber(0),
            RotationOrigin.centerCenter()
        );
    }

    public toCss():CSSProperties
    {
        if( this.isEnabled && this.isEnabled.value )
        {
            const transformProps:Array<string> = [];

            if( this.angleX.value !== 0 )
                transformProps.push(`rotateX(${this.angleX.value}deg)`);

            if( this.angleY.value !== 0 )
                transformProps.push(`rotateY(${this.angleY.value}deg)`);

            if( this.angle.value !== 0 )
                transformProps.push(`rotateZ(${this.angle.value}deg)`);

            if( transformProps.length > 0 )
                return {
                    transformOrigin: this.origin.value.value,
                    transform: transformProps.join(' ')
                };
        }

        return null;
    }
}
